// Shared wallet-summary API call — used by both dashboard's WalletCard and
// wallet's WalletBalanceBar — calls the local Mockoon mock server
// (apps/app/mocks/lendcord.mockoon.json, run via `pnpm mock:api`) at API_URL.
// RTK Query dedups this into one shared cache entry/one in-flight request
// across both consumers instead of each fetching independently.

import { baseApi } from "@/app/store/baseApi";
import type { WalletSummary } from "@/features/shared/walletSummary.types";

export const walletSummaryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWalletSummary: builder.query<WalletSummary, void>({
      query: () => ({ url: "/api/lender/wallet-summary" }),
      providesTags: ["WalletSummary"],
    }),
  }),
});

export const { useGetWalletSummaryQuery } = walletSummaryApi;
